import { SeverityImage } from "../../../models/IssueModels";
import { ImageMap, importAll } from "../template";

declare const require: any;

const images: ImageMap = importAll(
  require.context("../issue", false, /\.(png|jpe?g|svg)$/)
);

export default images;

export const getImage = (value?: string) => {
  return value && value.split("/").splice(1)[0].split(".").splice(0)[0];
};
const getValueByKey = (key: keyof typeof SeverityImage) => {
  return SeverityImage[key];
};

export const getIssueImg = (valueTemplateImage: string) => {
  const filteredImages = Object.entries(images).find(
    ([item, value], index) =>
      getImage(item) ===
      getValueByKey(
        valueTemplateImage.toUpperCase() as keyof typeof SeverityImage
      )
  );
  if (filteredImages) return filteredImages[1];
  else return "";
};
